<template>
	<div class="learner_program_requirment">
		<div class="row">
      <div class="col-12">
        <template v-if="isSelectedProgramRendered">
          <template v-if="selectedProgram.uuid">
            <b-card class="text-center prog-req ace_sec">
  						<template #header>
  							<div class="hd_ic">
  								<div class="ic ic22-dashboard1"></div>
  							</div>
          			<div class="hd_txt ace_sec_hd">
  								Academic Progress for {{selectedProgram.programTitle}}
								</div>

								<div class="hd_rgt_ic">
									<template v-if="showProgressLegend">
										<div class="legend-popup legends_sec">
											<div id="legendPopup4"></div>
											<div class="btn_legends" aria-label="progress legend">
													<div class="legends_container">
														<div class="btn_legends"
															id="progressLegends4"
															:title="$tf('legend')">
																<span class="sq_1 yellow"></span>
																<span class="sq_2 red"></span>
																<span class="sq_3 green"></span>
																<span class="sq_4 orange"></span>
														</div>

														<b-popover ref="legendModal4" target="progressLegends4" triggers="click focus" container="legendPopup4" placement="bottom" class="legend_popup_container">
															<template slot="title">
																<div class="row">
																	<div class="col-10 header-title"> {{ $tf('legend') }} </div>
																	<div class="col-2">
																		<b-btn
																			class="btn_close"
																			title="Close Legend Popup"
																			@click="closeLegendPopup">
																				<span class="ic-close"></span>
																		</b-btn>
																	</div>
																</div>
															</template>
															<div class="row">
																<div class="col-6 progress-section mt-2">
																	<div class="legend-title">Progress</div>
																	<div class="status_row"><span class="completed icon-progress"></span> completed</div>
																	<div class="status_row"><span class="in_progress icon-progress"></span> in progress</div>
																	<div class="status_row"><span class="failed icon-progress"></span> needs improvement</div>
																	<div class="status_row"><span class="not_started icon-progress"></span> not started</div>
																</div>
																<div class="col-6 performance-section mt-2">
																	<div class="legend-title">Performance</div>
																	<div class="status_row"><span class="lg_blc gradeA"></span> 90% - 100% </div>
																	<div class="status_row"><span class="lg_blc gradeB"></span> 80% - 89% </div>
																	<div class="status_row"><span class="lg_blc gradeC"></span> 65% - 79% </div>
																	<div class="status_row"><span class="lg_blc gradeD"></span> 40% - 64% </div>
																	<div class="status_row"><span class="lg_blc gradeE"></span>  0% - 39% </div>
																	<div class="status_row"><span class="lg_blc noGrade"></span>  N/A </div>
																</div>
															</div>
														</b-popover>
													</div>
												</div>
											</div>
										</template>

								</div>
        			</template>

  						<div class="crd_content">
  							<b-card-text>
  	              <div class="program_status_select_bx">
  									<div class="progress-row" v-if="showCourseProgress()">
                      <div class="progress-bar-label ace_sec_txt" :aria-label="inprogressCourses + ' of ' + totalCourses + ' courses'"></div>
                      <b-progress :max="totalCourses">
                        <b-progress-bar :value="completedCourses" :title="showBarTitle(completedCourses, 'completed')" class="prog_bar__completed" v-b-tooltip.hover>{{completedCourses}}</b-progress-bar>
                        <b-progress-bar :value="inprogressCourses" :title="showBarTitle(inprogressCourses, 'in-progress')" class="prog_bar__in_progress" v-b-tooltip.hover>{{inprogressCourses}}</b-progress-bar>
                        <b-progress-bar :value="notStartedCourses" :title="showBarTitle(notStartedCourses, 'not started')" class="prog_bar__not_started" v-b-tooltip.hover>{{notStartedCourses}}</b-progress-bar>
                      </b-progress>
                    </div>
                    <div class="progress-row" v-else>
                      <div class="progress-bar-label ace_sec_txt" :aria-label="childrenCompleteCount + ' of ' + childrenCount + ' competencies'">{{childrenCompleteCount}} of {{childrenCount}} competencies</div>
                      <b-progress :max="childrenCount">
                        <b-progress-bar :value="childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                      </b-progress>
                    </div>

  	              </div>
  	            </b-card-text>
  						</div>
  						<div class="lnk_container">
  							<div class="score_sec">
  								<span class="label">Score</span>
  					      <span class="progress_block" style="height: 32px; width: 70px;">
  					        <span class="state" :class="statusClass(score,hideScoreForStudent)" style="height: 32px; width: 70px;">
  					          <template v-if="isScoreNotAvailable || hideScoreForStudent">
                        <span class="progress_val ace_sec_txt" style="font-size: 15px;" aria-label="Score is not available">N/A</span>
                      </template>
                      <template v-else>
                        <span class="progress_val ace_sec_txt" style="font-size: 15px;" :aria-label="'Score is ' + score + '%'" >{{score}}%</span>
                      </template>
  					        </span>
  					      </span>
  				      </div>
  							<div class="sec_lnk">
  								<a href="javascript://" @click="navigateToProgramStatus" class="ace_sec_txt" tabindex="0" aria-label="My Progress">{{ showMyProgramStatusTabLabel() }}</a>
  							</div>
  						</div>
  					</b-card>
          </template>
          <template v-else>
            <b-card class="text-center prog-lmi ace_sec" aria-label="My Progress is data not available">
  						<template #header>
  							<div class="hd_ic">
  							</div>
          			<div class="hd_txt">
  								{{ $tf('myProgress') }}
  							</div>
        			</template>
  						<div class="crd_content">
  	            <b-card-text>
  	              <div class="mt-5">
  	                <span>Data not available.</span>
  	              </div>
  	            </b-card-text>
  						</div>
  						<div class="lnk_container">
  						</div>
            </b-card>
          </template>
        </template>
        <template v-else>
          <b-card class="text-center prog-req ace_sec">
            <template #header>
              <div class="hd_ic">
                <div class="ic ic22-dashboard1"></div>
              </div>
              <div class="hd_txt ace_sec_hd">
                {{ $tf('academicProgress') }}
              </div>
            </template>
            <div class="crd_content">
              <b-card-text>
                <div class="text-center mt-5">
                  <stretch></stretch>
                </div>
              </b-card-text>
            </div>
          </b-card>
        </template>
      </div>
    </div>

	</div>
</template>

<script>
	import _ from 'lodash'
	import { mapState, mapActions } from 'vuex'
  //import {Stretch} from 'vue-loading-spinner'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
	import '../../../assets/module/css/common/legendsPopover.min.css'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)
	export default {
		name: 'learner-program-competency-progress',
    components: {
      //Stretch
    },
    props: ['program'],
    data: () => {
    	return {
    		score: 0,
    		childrenCount: 0,
    		childrenCompleteCount: 0,
        totalCourses : 0,
        completedCourses : 0,
        inprogressCourses : 0,
        notStartedCourses : 0,
        courses : [],
    		isScoreNotAvailable: true,
    		progressSummaryCount: 0,
    		selectedProgram: {},
        isSelectedProgramRendered: false,
        hideScoreForStudent:false
    	}
    },
    beforeMount () {
    	this.populateStreamStructure(this.selectedProgram.programCode)
      this.populateProgram(this.selectedProgram)
    },
    mounted () {
    	this.$root.$on('reloadCompetencyProgress', (data) => {
    		this.selectedProgram = data
	      this.populateStreamStructure(data.programCode)
        this.isSelectedProgramRendered = true
        this.populateProgram(data)
	    })
    },
    methods: {
    	...mapActions([
        'loadStreamWithStructure',
        'loadCompetencyProgress',
        'loadMicroCompetencyProgress',
        'loadProgramGuide',
        'loadStreamWithStructure',
        'loadStreamWithStructureSummary'
      ]),
      resetData () {
      	this.score = 0
        this.childrenCount = 0
        this.childrenCompleteCount = 0
        this.progressSummaryCount = 0
        this.isScoreNotAvailable = true
        this.totalCourses = 0
        this.completedCourses = 0
        this.inprogressCourses = 0
        this.notStartedCourses = 0
        this.courses = []
      },
      async populateProgram (data) {
          let currentProgram = await this.loadProgramGuide({
          cipCode: data.programCipCode,
          programGuideCode: data.programCode,
          type: data.programType,
          loadDataFromServer: true
        })
        this.hideScoreForStudent = currentProgram.hideScoreForStudent
      },
      async populateStreamStructure (programCode) {
      	this.resetData()
        let userObj = JSON.parse(localStore.getItem('userobj'))
        let stream = await this.loadStreamWithStructure({programCode: programCode, userId: userObj.uuid})
        let structure = stream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0 && children.length <2) {
            let childStructure = children[0].structure
            if (childStructure) {
              let cStructure = JSON.parse(childStructure)
              this.courses = _.sortBy(cStructure, 'order')
            }
          }else{
            let structure1 = JSON.parse(structure)
            this.courses = _.sortBy(structure1, 'order')
          }
        }

        let performance = 0
        let summaries = await this.loadStreamWithStructureSummary({programCode: programCode})
        for (let i = 0; i < summaries.length; i++) {
            let competencySummary =  summaries[i]
            competencySummary.uuid = programCode + '_' + competencySummary.uuid
            this.childrenCount += competencySummary.childrenCount
            this.childrenCompleteCount+= competencySummary.childrenCompleteCount
            if (competencySummary.performance && competencySummary.status>0) {
                  this.isScoreNotAvailable = false
                  performance += competencySummary.performance
                  this.progressSummaryCount+=1
            }
            if(competencySummary.status==1){
              this.inprogressCourses +=1
            }
            if(competencySummary.status==2){
              this.completedCourses +=1
            }

        }
        let catalogAndCourses = this.getTotalCourseCatalogs(this.courses)
        this.totalCourses = catalogAndCourses.length
        this.notStartedCourses = (this.totalCourses - (this.inprogressCourses+this.completedCourses))
        this.score = (performance / this.progressSummaryCount).toFixed(2)

/*
        await this.loadStreamWithStructure({programCode: programCode})
        let structure = this.planningStream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0) {
            let childStructure = children[0].structure
            if (childStructure) {
              let children = JSON.parse(childStructure)
              let courses = _.filter(children, (child) => {
			          return (child.entityType === 'deliverycontext')
			        })
			        for (let i = 0; i < courses.length; i++) {
                let course = courses[i]
                let courseId = course.originUuid
                let mcSummary = await this.loadMicroCompetencyProgress({entityId: courseId, loadDataFromServer: true})
                this.childrenCount += mcSummary.childrenCount
                this.childrenCompleteCount += mcSummary.childrenCompleteCount
                let competencySummary = await this.loadCompetencyProgress({entityId: courseId, loadDataFromServer: true})
                if (competencySummary && ((competencySummary.status === 1) || (competencySummary.status === 2))) {
                  performance += competencySummary.performance
                  this.progressSummaryCount += 1
                }
              }
              this.score = (performance / this.progressSummaryCount).toFixed(2)

              setTimeout(() => {
                if (this.score >= 0.00) {
                  this.isScoreNotAvailable = false
                } else {
                  this.isScoreNotAvailable = true
                }
			        }, 1000)
 */
      },
      getTotalCourseCatalogs(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getTotalCourseCatalogs(recursionEntities)
                 courses.push(...response)
               }
             }
           } else {
             courses.push(item)
           }

        })

        return courses
      },
			navigateToProgramStatus () {
        let routerParams = {
          cipCode: this.selectedProgram.programCipCode,
          programGuideCode: this.selectedProgram.programCode,
          type: this.selectedProgram.programType,
          returnTo: 'learnerDashboard',
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideMyProgramStatus', params: routerParams, query: {returnTo: 'learnerDashboard'}})
      },
      showCourseProgress () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
    showMyProgramStatusTabLabel () {
      let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramProgress' && flags[i].label) {
              return flags[i].label
            }
          }
        }
        return 'My Progress'
    },

      statusClass (score, hideScoreForStudent) {
        if (score && !this.isScoreNotAvailable && !hideScoreForStudent) {
          if (score >= 90) {
            return 'gradeA'
          } else if (score >= 80 && score < 90) {
            return 'gradeB'
          } else if (score >= 65 && score < 80) {
            return 'gradeC'
          } else if (score >= 40 && score < 65) {
            return 'gradeD'
          } else if (score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
			showBarTitle (count, status) {
        if (count > 1) {
          return count + ' courses are ' + status
        } else {
          return count + ' course is ' + status
        }
      },
			closeLegendPopup () {
				this.$refs.legendModal4.$emit('close')
			}
		},
		computed: {
      ...mapState({
        'planningStream': state => state.dashboard.planningStream,
        'learnerEnrollmentData': state => state.dashboard.learnerEnrollmentData,
        'packages': state => state.institution.packages,
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      showProgressLegend () {
        // show progress legend
        let legendFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.LEGEND_FEATURE_ID]
        if (legendFeature && legendFeature.enabled) {
          let flags = legendFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgressLegend') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
    }
	}
</script>

<style scoped>
  .prog-req .card-header {
    height: 65px;
    padding-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProgramCompetencyProgress.vue